const AI_INNER_ALERT_PATHS = new Set(['/bill', '/details'])

export const canShowAiInnerAlertOnPath = (path: string) => AI_INNER_ALERT_PATHS.has(path)
